import { UserSummaryType } from '../../../api/types/user/user-summary.type';
import React, { useMemo, useState } from 'react';
import { StudentSideBarItemType } from '../../../component/side-bar-user/componenets/side-bar-student-item';
import { UserPageProfile } from '../pages/profile/user-page-profile';
import { UserPageAcademic } from '../pages/user-page-programms/user-page-academic';
import { UserPageDocs } from '../pages/docs/user-page-docs';
import { UserPagePayments } from '../pages/user-page-payments';
import { UserPagePermissions } from '../pages/user-page-permissions/user-page-permissions';
import { SideBarStudent } from '../../../component/side-bar-user/side-bar-student';
import globalUserPage from '../../../stores/global-user-page';
import { UserPageStudentLectures } from '../pages/student/user-page-student-lectures';
import { UserPageStudentExams } from '../pages/student/user-page-student-exams';
import { UserPageStudentAssignments } from '../pages/student/user-page-student-assignments';
import { UserPageStudentExternalExams } from '../pages/student/external-exams/user-page-student-external-exams';
import { UserPageStudentInstallments } from '../pages/student/installments/user-page-student-installments';
import { UserPageStudentInstallmentsBankTransfer } from '../pages/student/installment-bank-transfer/installment-bank-transfer';
import appApi from '../../../api/app-api';
import { toast } from 'react-toastify';
import { observer } from 'mobx-react-lite';

interface UserPageStudentDatamodel {
  user: UserSummaryType;
}

export const UserPageStudent: React.FC<UserPageStudentDatamodel> = observer(
  ({ user }) => {
    const [itemSelectedType, setItemSelectedType] =
      useState<StudentSideBarItemType>(StudentSideBarItemType.PROFILE);

    const loadStudentDetails = async () => {
      const updatedUserDetails = await appApi.getUserStudentDetails(user.id);
      globalUserPage.studentDetails = updatedUserDetails.data.body;
    };
    const studentDetails = useMemo(() => {
      return globalUserPage.studentDetails;
    }, [globalUserPage.studentDetails]);

    const getElementItem = (itemType: StudentSideBarItemType) => {
      switch (itemType) {
        case StudentSideBarItemType.PROFILE:
          return <UserPageProfile user={user} />;
        case StudentSideBarItemType.ACADEMIC:
          return (
            <UserPageAcademic
              programs={studentDetails?.programWithCourses ?? []}
              user={user}
              loadStudentDetails={loadStudentDetails}
            />
          );
        case StudentSideBarItemType.DOCS:
          return (
            <UserPageDocs user={user} loadUserDocuments={loadStudentDetails} />
          );
        case StudentSideBarItemType.PAYMENT_SERVICES:
          return <UserPagePayments user={user} />;
        case StudentSideBarItemType.PERMISSIONS:
          return <UserPagePermissions />;
        case StudentSideBarItemType.LECTURES:
          return <UserPageStudentLectures />;
        case StudentSideBarItemType.EXAMS:
          return <UserPageStudentExams />;
        case StudentSideBarItemType.ASSIGNMENTS:
          return <UserPageStudentAssignments />;
        case StudentSideBarItemType.EXTERNAL_EXAMS:
          return <UserPageStudentExternalExams isStudentMode={false} />;
        case StudentSideBarItemType.INSTALLMENTS_CREDIT_CARD:
          return <UserPageStudentInstallments user={user} />;
        case StudentSideBarItemType.INSTALLMENTS_BANK_TRANSFER:
          return <UserPageStudentInstallmentsBankTransfer user={user} />;
      }
    };

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: '8px',
        }}
      >
        <SideBarStudent
          onClick={(type) => {
            setItemSelectedType(type);
          }}
        />
        {getElementItem(itemSelectedType)}
      </div>
    );
  },
);
